import React from "react";
import avatar from './avatar.png';
import classes from "../MobileAppPreview.module.scss";
import TopNavBarSvg from "./TopNavBarSvg";

const TopNavBar = ({isSplashAndSignInUpPage}) => {
    return(
     <div className={classes.topBarContainer} >
        {!isSplashAndSignInUpPage && <img src={avatar}  className={classes.topBarAvatar} alt="avatar" />}
        <TopNavBarSvg isSplashAndSignInUpPage={isSplashAndSignInUpPage} />
     </div>
    )
}

export default TopNavBar